angular.module('bribac.components.appLayout', [
  'bribac.values',
  'bribac.components.mainMenu'
])

  .component('appLayout', {
    templateUrl: 'app-layout-component.html',
    controller: 'AppLayoutComponentCtrl'
  })

  .controller('AppLayoutComponentCtrl', function(
    $scope,
    $window,
    $timeout,
    state
  ) {
    this.state = state

    var delayedScrollReset

    function scrollReset() {
      document.body.scrollTop = 0
      document.body.scrollLeft = 0
      document.documentElement.scrollTop = 0
      document.documentElement.scrollLeft = 0
    }

    $scope.$on('$routeChangeSuccess', function() {
      // Reset the scroll position when navigating to a new route.
      //
      // Use a delay so we can cancel the reset when the browser back/forward
      // feature is used. See 'popstate' comment.
      delayedScrollReset = $timeout(scrollReset, 20)
    })

    $window.addEventListener('popstate', function() {
      // The 'popstate' event is triggered when the user uses the browser
      // back/forward feature, in which case we don't want to reset the scroll.
      // It will be triggered after '$routeChangeSuccess' so we can use it to
      // cancel the delayed scroll reset.
      $timeout.cancel(delayedScrollReset)
    })
  })
